import React from 'react';

import { RuleRead } from '@ariksa/compliance-policies/api';
import {
  AggregatedAlertDetails,
  AlertResponse,
} from '@ariksa/notification/api';
import { Box, useDisclosure } from '@chakra-ui/react';

import { ActionButton, PolicyExceptionIcon } from 'app/components';
import { AddException } from 'containers/Findings/Alerts/Components/AddException';
import { ExceptionFor } from 'containers/Findings/FindingsOverview/types';

export interface AddExceptionActionButtonProps {
  alert?: AlertResponse;
  aggregatedAlert?: AggregatedAlertDetails;
  exceptionFor: ExceptionFor;
  label?: string;
  isDisabled?: boolean;
}

export const AddExceptionActionButton = (
  props: AddExceptionActionButtonProps,
) => {
  const { label = 'Add Exception', isDisabled } = props;
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <Box>
      <ActionButton
        label={label}
        icon={<PolicyExceptionIcon />}
        isDisabled={isDisabled}
        onClick={e => {
          e.stopPropagation();
          onOpen();
        }}
      />
      {isOpen && <AddException isOpen={isOpen} onClose={onClose} {...props} />}
    </Box>
  );
};
